<script>
const paymentTypeLookup = {
  0: 'Cash',
  4: 'Debit',
  2: 'Credit',
  1: 'Other',
  3: 'Gift Card',
}

export default {
  computed:{
    pivotedData(){
      const result = {}
      this.$locations.forEach(location => {
        if(this.data[location].isLoading)
          return;
        let shifts = []
        let pivotShiftsMediaTypesCounts = this.pivotShiftsMediaTypesCounts(location)
        let pivotShiftsMediaTypes = this.pivotShiftsMediaTypes(location)
        let shiftsJson = this.flattenShiftsJson(location)
        let data = this.cleanShifts(location)
        shifts = this.$util.mergeArrays([data, pivotShiftsMediaTypesCounts, pivotShiftsMediaTypes, shiftsJson])
        
        result[location] = {shifts}
      })
      return result;
    }
  },
  methods:{

    cleanShifts(location){
      if(this.data[location].isLoading)
        return 
      let result = this.data[location].shifts;
      result = this.$util.deleteObjectsProperties(result, ['RowID'])
      return result;
    },
    
    flattenShiftsJson(location){
      if(this.data[location].isLoading)
        return 
      let result = [];
      this.data[location].shifts.forEach(row => result.push(this.flattenShiftsJsonRow(row)))
      return result;
    },

    flattenShiftsJsonRow(row){
      let result = row.shiftsJson.data ? row.shiftsJson.data : JSON.parse(this.defaultDataEntryObj)
      result = {...result, ...result.deductions}
      result.cashier = result.cashiers[0]
      delete result.cashiers;
      delete result.deductions;
      return result;
    },

    pivotShiftsMediaTypesCounts(location){
      if(this.data[location].isLoading)
        return 
      let result = [];
      this.data[location].shifts.forEach(row => result.push(this.pivotShiftsMediaTypesCountsRow(row)))
      
      const mapping = {}
      Object.keys(paymentTypeLookup).forEach(k=>{
        mapping[`${k}_Open`] = `${paymentTypeLookup[k]}_Open`;
        mapping[`${k}_Close`] = `${paymentTypeLookup[k]}_Close`;
        mapping[`${k}_OverShort`] = `OverShort`;
      })
      result = this.$util.renameObjects(result, mapping);
      result = this.$util.deleteObjectsProperties(result, ['RowID'])
      
      return result;
    },

    // ======================
    // shiftsMediaTypesCounts
    //     "CloseAmount": 1198.95,
    //     "MediaType": 0,
    //     "OpenAmount": 880,
    //     "OverShort": -114.26,
    //     "RowID": "9c79e20d-cdf7-466d-a6a7-a3e74c942714",
    //     "Store_ID": "1001",
    //     "SuggestedOpenAmount": 880
    pivotShiftsMediaTypesCountsRow(row){    
      const data = row.shiftsMediaTypesCounts.filter(r=>r.MediaType === 0)
      const rowKeys = ['RowID']
      const colKeys = ['MediaType']
      const functions = [['sum', 'CloseAmount', 'Close'], ['sum', 'OpenAmount', 'Open'], ['sum', 'OverShort', 'OverShort']]
      const pivot = this.$pivot.pivot(data, rowKeys, colKeys, functions);
      
      const keyOrder = []
      let pivotRow = this.$pivot.toRow(pivot, keyOrder, ' - ');
      return pivotRow;
    },

    pivotShiftsMediaTypes(location){
      if(this.data[location].isLoading)
        return 
      let result = [];
      this.data[location].shifts.forEach(row => result.push(this.pivotShiftsMediaTypesRow(row)))
      // this.pivotedData[location] = result
      const mapping = {}
      Object.keys(paymentTypeLookup).forEach(k=>{
        mapping[`${k}_Amount`] = paymentTypeLookup[k];
        mapping[`${k}_#`] = `${paymentTypeLookup[k]}_#`;
        mapping[`${k}_SD`] = `${paymentTypeLookup[k]}_SD`;
      })
      result = this.$util.renameObjects(result, mapping)
      result = this.$util.deleteObjectsProperties(result, ['RowID', 'Debit_SD', 'Credit_SD', 'Other_SD', 'Gift Card_SD'])
      result = this.$util.renameObjects(result, {'Cash_SD' : 'Safe Drops'})
      return result;
    },

    // ======================
    // shiftsMediaTypes
    // "Cashback": 0,
    //   "MediaTotal": 9183.81,
    //   "MediaType": 4,
    //   "NumSales": "200",
    //   "Payouts": 0,
    //   "RowID": "9c79e20d-cdf7-466d-a6a7-a3e74c942714",
    //   "SafeDrops": 0,
    //   "Store_ID": "1001",
    //   "TipsCollected": 0
    pivotShiftsMediaTypesRow(row){    
      const data = row.shiftsMediaTypes
      const rowKeys = ['RowID']
      const colKeys = ['MediaType']
      const functions = [['sum', 'MediaTotal', 'Amount'], ['sum', 'NumSales', '#'], ['sum', 'SafeDrops', 'SD']]
      const pivot = this.$pivot.pivot(data, rowKeys, colKeys, functions);

      const keyOrder = []
      let pivotRow = this.$pivot.toRow(pivot, keyOrder, ' - ');
      return pivotRow;
    },
  },
}
</script>